import { useTranslation } from 'react-i18next';
import { Alert } from 'ui';

type P = {
  count: number;
};

const InvitationLimitAlert = ({ count }: P) => {
  const { t } = useTranslation();

  return (
    <Alert
      className="invitation-limit-alert"
      title={t("You've reached the {{count}}-invitation limit for your role. Remove someone to add another.", {
        count,
      })}
      type="warning"
    />
  );
};

export default InvitationLimitAlert;
